import {serverSideTranslations} from 'next-i18next/serverSideTranslations';

import SignInContainer from '@/src/authentication/signIn/containers/SignInContainer';

const SignIn = () => {
  return <SignInContainer />;
};

export default SignIn;

export const getStaticProps = async ({locale}) => ({
  props: {
    ...(await serverSideTranslations(locale, ['common'])),
  },
});
